// extracted by mini-css-extract-plugin
export default {"zoomModal":"baa-z","image":"caa-z","button":"daa-z","isOverlayShown":"eaa-z"};